<div class="container-fluid">
  <p-toast [style]="{marginTop: '80px'}"></p-toast>
  @if (formLoading) {
    <div class="progress-spinner">
      <app-spinner [formLoading]="formLoading"></app-spinner>
    </div>
  }

  <h2>Occupancy Dashboard</h2>

  @if (showSearchUI) {
    <app-search-template searchLabel="Search" [showSearchButton]=true [reset]=false [showLocations]=true [showDevelopments]=true
      [showShortTermRentals]=true [showRateBuckets]=false [showBedrooms]=true [showViewTypes]=true [showSeasons]=false
      [showReservationStatuses]=false [showStartDate]=true [showEndDate]=true [showSaleDateStart]=false
      [showSaleDateEnd]=false [showListingStatus]=false [defaultStartDate]="defaultStartDate" [showSaleYear]=false
      [defaultEndDate]="defaultEndDate" [defaultShortTermRentalIds]="defaultShortTermRentalIds"
      [showCustomDateRange]="true" [dateRange]="'month'" [dateRangeNumber]="6"
      [defaultReservationStatuses]="defaultReservationStatuses" (doSearchCB)="onSearchSubmit($event)">
    </app-search-template>
  }

  <div class="occupany_table">
    <p-table #pt [value]="reservations" [ngStyle]="{'width': 'auto'}"
      [resizableColumns]="true" [autoLayout]="true" [responsive]="true" [scrollable]="true"
      scrollHeight="600px" [tableStyle]="{'min-width': '50rem'}">

      <ng-template pTemplate="header">
        <tr>
          @for (col of columns; track col) {
            <th rowspan="2" pFrozenColumn [pSortableColumn]="col.field" [ngStyle]="{'width': '50px'}">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          }

          @for (col of monthColumns; track col) {
            <th [attr.colspan]="col.colspan">
              {{col.month | date:'MMMM y'}}
            </th>
          }
          <th [ngStyle]="{'width': 'auto'}"></th>
        </tr>
        <tr>
          @for (col of dateColumns; track col) {
            <th>
              {{col.dateObj | date:'dd EEE'}}
            </th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-reservation>
        <tr>
          <td pFrozenColumn>{{reservation.propertyCode}} </td>
          <td pFrozenColumn>{{reservation.developmentName}}</td>
          <td pFrozenColumn>{{reservation.viewName}}</td>
          <td pFrozenColumn>{{reservation.numBedrooms}}</td>
          @for (reservationDate of reservation.reservationDates; track reservationDate) {
            <td [style.background-color]="reservationDate.bookStatus == 'AIR' ? '#8BC34A' : (reservationDate.bookStatus == 'AOR' ? 'green' : (reservationDate.bookStatus == 'NAO' ? 'grey' : (reservationDate.bookStatus == 'NAI' ? '#D3D3D3' : 'red')))">
              @if (reservationDate.bookStatus == 'NAO' || reservationDate.bookStatus == 'NAI') {
                <p>
                  <a href="javascript:void(0)" style="color:#000;" (click)="showReservation(reservationDate.reservationId, reservationDate.reservation)">{{reservationDate.bookStatus ? reservationDate.revRoomRateNetPNT: ''}}</a>
                </p>
              }
              @if (reservationDate.bookStatus == 'AIR' || reservationDate.bookStatus == 'AOR') {
                <p>
                  {{reservationDate.bookStatus ? reservationDate.revRoomRateNetPNT: ''}}
                </p>
              }
              @if (reservationDate.bookStatus != 'AIR' && reservationDate.bookStatus != 'AOR' && reservationDate.bookStatus != 'NAO' && reservationDate.bookStatus != 'NAI') {
                <p>
                  No Data
                </p>
              }
            </td>
          }
          <td></td>
        </tr>
      </ng-template>
    </p-table>
  </div>
